export const NO_REPEAT = "no repeat";
export const EVERY_WEEKDAY = "every weekday";
export const DAILY = "daily";
export const WEEKLY = "weekly";
export const BIWEEKLY = "biweekly";
export const MONTHLY = "monthly";
export const YEARLY = "yearly";
